import { publicApiClient } from './publicApiClient';

export interface PartnerAccount { id: number; fullName: string; email: string; organizationName: string }

export const partnerPortalApi = {
  register: (input: { email: string; password: string; fullName: string; organizationName: string; phone?: string }) =>
    publicApiClient.post<{ data: { message: string } }>('/api/partner/auth/register', input),
  verifyEmail: (token: string) => publicApiClient.get<{ data: { message: string } }>(`/api/partner/auth/verify-email?token=${encodeURIComponent(token)}`),
  login: (input: { email: string; password: string }) => publicApiClient.post<{ data: PartnerAccount }>('/api/partner/auth/login', input),
  logout: () => publicApiClient.post<{ data: { message: string } }>('/api/partner/auth/logout'),
  me: () => publicApiClient.get<{ data: PartnerAccount | null }>('/api/partner/auth/me'),
  forgotPassword: (email: string) => publicApiClient.post<{ data: { message: string } }>('/api/partner/auth/forgot-password', { email }),
  resetPassword: (token: string, newPassword: string) => publicApiClient.post<{ data: { message: string } }>('/api/partner/auth/reset-password', { token, newPassword }),
  checkEmail: (email: string) => publicApiClient.get<{ data: { isPartner: boolean } }>(`/api/partner/auth/check-email?email=${encodeURIComponent(email)}`),
};
